
export const getClient = /* GraphQL */ `
  query GetClient($id: ID!) {
    getClient(id: $id) {
      id
      name
      address {
        street
        district
        county
      }
      phoneNumber
      receiptInfo {
        taxIdNumber
      }
      facilitySettings {
        receiptInfo {
          taxIdNumber
        }
        companyStampS3Keys
      }
    }
  }
`;

export const getOrdersByClientByDate = /* GraphQL */ `
  query GetOrdersByClientByDate(
    $clientId: ID
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getOrdersByClientByDate(
      clientId: $clientId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        individualId
        date
        status
        total
        mealItems {
          name
          quantity
          price
          cost
          note
          surcharges {
            name
            price
          }
        }
        elder {
          name
          phoneNumber
          address {
            street
            district
            county
          }
        }
      }
      nextToken
    }
  }
`;
